<template>
  <el-dialog
      :title="$t('socialPosts.confirmDelete.title')"
      :visible.sync="modalDelete"
      v-loading="loadingStatus"
      width="45%">
        <span class="text-left">
          <div v-if="postToDelete.length === 1">
            {{ $t('socialPosts.confirmDelete.confirmDeleteSingle') }} <ul><li v-for="post in postToDelete">{{post.titre}}</li></ul>  {{ $t('socialPosts.confirmDelete.onlyNotDiffused') }}
          </div>
          <div v-else-if="postToDelete.length > 1">
            {{ $t('socialPosts.confirmDelete.confirmDeleteMultiple') }} <ul><li v-for="post in postToDelete">{{post.titre}}</li></ul>  {{ $t('socialPosts.confirmDelete.onlyNotDiffused') }}
          </div>
          <div v-else-if="postToDelete.length === 0">
            {{ $t('socialPosts.confirmDelete.notPossible') }}
          </div>
          <br>
          <br>
          <div v-if="postToDelete.length > 0 && countDiffusionsActives > 0">
            <strong>{{ $t('socialPosts.confirmDelete.warningTitle') }}</strong><br>
            {{ $t('socialPosts.confirmDelete.warningPublished') }}
            <ul>
              <li v-for="diffusion in bilanDiffusions">
                {{diffusion}}
              </li>
            </ul>
            {{ $t('socialPosts.confirmDelete.confirmChoice') }}
          </div>
        </span>
    <span slot="footer" class="dialog-footer">
          <el-button @click="setModalDelete(false)" v-if="postToDelete.length > 0">{{ $t('socialPosts.confirmDelete.cancel') }}</el-button>
          <el-button @click="setModalDelete(false)" v-if="postToDelete.length === 0">{{ $t("dashboard.dialogClose") }}</el-button>
          <el-button type="primary" @click="$emit('confirm-delete-posts', postToDelete)" v-if="postToDelete.length > 0">{{ $t('socialPosts.confirmDelete.confirmDelete') }}</el-button>
        </span>
  </el-dialog>

</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {

  name: 'ConfirmDeletePosts',
  props: ['annonce', 'modalVisible'],
  data () {
    return {
      bilanDiffusions: [],
      countDiffusionsActives: 0
    }
  },
  watch: {
    postToDelete: function (val) {
      this.displayPostsWithDiffusions()
    }
  },
  computed: {
    ...mapState('socialPostsTableAnnonces', ['modalDelete', 'postToDelete', 'loadingStatus']),
    modalDelete: {
      get () {
        return this.$store.state.socialPostsTableAnnonces.modalDelete
      },
      set (value) {
        this.$store.commit('socialPostsTableAnnonces/setModalDelete', value)
      }
    }
  },
  methods: {
    ...mapMutations('socialPostsTableAnnonces', ['setModalDelete']),
    displayPostsWithDiffusions () {
      this.bilanDiffusions = []
      this.countDiffusionsActives = 0
      const self = this
      this.postToDelete.forEach(function (post) {
        if (post.diffusions && post.diffusions.length > 0) {
          self.checkDiffusions(post)
        }
      }, self)
      return this.bilanDiffusions
    },
    checkDiffusions (post) {
      const self = this
      post.diffusions.forEach(function (diffusion) {
        if(diffusion.firstSentAt) {
          self.countDiffusionsActives = self.countDiffusionsActives + 1
          const chaine = post.titre + ' : ' + diffusion.diffuseurName
          self.bilanDiffusions.push(chaine)
        }
      }, self)
    }
  }
}
</script>

<style scoped>
</style>
